var map = {
	"./img_1.jpg": 27893,
	"./img_2.jpg": 11248,
	"./img_3.jpg": 77876,
	"./img_4.jpg": 15848,
	"./img_5.jpg": 76481,
	"./img_6.jpg": 79600,
	"./img_7.jpg": 94212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6207;